import { Icon } from "@chakra-ui/react";
const CallReceivedIcon = () => {
  return (
    <>
      <Icon
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5_34)">
          <path
            d="M3.43728 0.564624C3.41353 0.57056 3.30076 0.588366 3.19393 0.606172C2.97432 0.641784 2.54104 0.790168 2.27988 0.926681C2.01873 1.05726 1.73977 1.27093 1.47861 1.52615C0.303412 2.68948 0.238123 4.44634 1.29462 6.49997C1.97125 7.81762 2.95651 9.09965 4.4819 10.6191C5.98948 12.1267 7.28932 13.1298 8.60103 13.8064C10.3816 14.7204 11.9367 14.7917 13.0882 14.026C13.5036 13.753 13.9606 13.2425 14.1743 12.8211C14.4117 12.3582 14.5779 11.7112 14.5423 11.4085C14.5067 11.0939 14.2871 10.8506 13.8597 10.6428C13.5452 10.4945 11.545 9.74067 11.2957 9.68132C11.0464 9.61603 10.9396 9.61603 10.7556 9.66945C10.5122 9.74067 10.3994 9.87125 10.1323 10.3995C9.87119 10.9159 9.82965 10.9752 9.66939 11.0583C9.52694 11.1295 9.17676 11.1533 8.90967 11.1058C8.60103 11.0524 7.73447 10.5776 7.15874 10.1502C6.45837 9.62197 5.50278 8.67231 4.98047 7.97787C4.57093 7.43182 4.07829 6.55933 4.00113 6.25069C3.94178 5.9836 3.95959 5.57999 4.03675 5.43161C4.11984 5.27136 4.17919 5.22387 4.65996 4.98646C4.90331 4.86775 5.15259 4.71937 5.21195 4.67189C5.42562 4.48789 5.50278 4.21486 5.43155 3.87061C5.38407 3.63913 4.57686 1.47273 4.42848 1.17597C4.29197 0.908875 4.11391 0.707073 3.93585 0.629913C3.80527 0.576495 3.53224 0.540883 3.43728 0.564624Z"
            fill="#39C449"
          />
          <path
            d="M13.3315 0.594284C13.2899 0.618025 12.5777 1.30653 11.7527 2.13154L10.251 3.62725L9.61593 2.99216C9.26575 2.64198 8.95117 2.34521 8.91556 2.32741C8.76718 2.25618 8.54757 2.33334 8.46447 2.49359C8.41699 2.58263 8.41699 2.70133 8.41699 4.48787C8.41699 6.28035 8.41699 6.39312 8.46447 6.48215C8.49415 6.53557 8.55944 6.60086 8.60692 6.6246C8.69595 6.67208 8.81466 6.67208 10.5953 6.67208C12.732 6.67208 12.6252 6.68395 12.7379 6.47028C12.7854 6.38125 12.7973 6.33376 12.7795 6.24473C12.7617 6.14977 12.6786 6.06074 12.1088 5.48501L11.4618 4.83806L12.9872 3.31267C14.6372 1.66265 14.5898 1.71606 14.5185 1.49646C14.4829 1.38962 13.7173 0.618025 13.6045 0.570542C13.5036 0.53493 13.4264 0.540865 13.3315 0.594284Z"
            fill="#39C449"
          />
        </g>
        <defs>
          <clipPath id="clip0_5_34">
            <rect width="15" height="15" fill="white" />
          </clipPath>
        </defs>
      </Icon>
    </>
  );
};
export default CallReceivedIcon;
